import React from "react";
import "./NavBar.css";
import { NavLink as Link } from "react-router-dom";
import { routes } from "../constants/Routes";
import logoMace from "../img/logoMace.png";

export default function NavBar() {
  return (
    <div className="navbar">
      <div className="content flex items-center ml-auto mr-auto">
        <div className="logo">
          <a href="https://www.mace-legal.com" className="link">
            <img src={logoMace} className="logoImage" />
          </a>
        </div>
        <Link className="link ml-auto" to={routes.help}>
          <div className="button mr-4">Contact</div>
        </Link>
      </div>
    </div>
  );
}
